import { render, staticRenderFns } from "./lucky.vue?vue&type=template&id=570b203d&scoped=true"
import script from "./lucky.vue?vue&type=script&lang=js"
export * from "./lucky.vue?vue&type=script&lang=js"
import style0 from "./lucky.vue?vue&type=style&index=0&id=570b203d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b203d",
  null
  
)

export default component.exports